import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import PointParkingService from '../services/PointParkingService';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';

const PointParking = () => {
    const [form, setForm] = useState({});
    const [form2, setForm2] = useState({});
    return(
        <div>
            <div className="card">
                <Table {...{setForm, setForm2}} />
                <Form {...{form}} />
                <Form2 {...{form2}} />
            </div>
            
        </div>
    );
}

const Table = (props) =>{
    const [items, setItems] = useState([]);
    const [items2, setItems2] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const { setForm, setForm2 } = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        PointParkingService.getCvaDisponible((data, status) => {
                setLoading(false);
                if(status) setItems(data); 
                  
            },
            {date: new Date().toISOString().slice(0, 10)}
        ); 

        PointParkingService.get((data, status) => {
            setLoading(false);
            console.log(JSON.stringify(data, null, 2));
            if(status) setItems2(data);   
        },
            //{date: new Date().toISOString().slice(0, 10)}
            { etat: "EN_PANNE"}
        );
    }

    const vehiculePanne = ()=>{
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
        })
    }

    const vehiculeBonEtat = ()=>{
        setForm2({
            visible: true,
            hide: ()=> setForm2((prev)=>({...prev, visible: false})),
        })
    }


    return (
        <>
            <div className="my-2">
                

            </div>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Véhicule en panne" icon="pi pi-align-justify" className="p-button-success mr-2"
                                onClick={vehiculePanne} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Véhicule en bon état" icon="pi pi-align-justify" className="p-button-success mr-2"
                                onClick={vehiculeBonEtat} />
                        </div>
                    </React.Fragment>
                } />
            <div className='card'>
                <h5>Liste des véhicules</h5>
                <DataTable dataKey="id" value={items2}
                    paginator rows={itemPerPage} /*first={first}  
                    totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}*/
                    loading={loading} globalFilter={globalFilter}
                    responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                    <Column field="id" header="Identifiant" sortable hidden />
                    <Column field="immatriculation" header="Immatriculation" sortable />
                    <Column field="marque" header="Marque" sortable />
                    <Column field="modele" header="Modèle" sortable />
                    <Column field="nbrePlace" header="Nombre de places" sortable />
                    <Column field="etatVehicule" header="Etat" sortable body={(item2) =>
                        <span className={`customer-badge status-${item2.etatVehicule === 'DISPONIBLE' ? 'qualified' : 'unqualified'}`}>
                            {item2.etatVehicule}
                        </span>
                    } />
                    <Column field="institution.libelle" header="Institution" sortable />
                </DataTable>
            </div>


            <div className='card'>
                <h5>Liste des chauffeurs</h5>
                <DataTable dataKey="id" value={items}
                    paginator rows={itemPerPage}
                    loading={loading} globalFilter={globalFilter}
                    responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                    <Column field="id" header="Identifiant" hidden sortable />
                    <Column field="matricule" header="Matricule" sortable />
                    <Column header="Nom" sortable style={{ fontWeight: 'bold' }} body={(item) => item.nom + " " + item.prenom} />
                    <Column field="telephone" header="Téléphone" sortable />
                    <Column field="institution.libelle" header="Institution" sortable />
                    <Column field="etatChauffeur" header="Etat chauffeur" sortable body={(item) =>
                        <span className={`customer-badge status-${item.etatChauffeur == 'DISPONIBLE' ? 'qualified' : 'unqualified'}`}>
                            {item.etatChauffeur}
                        </span>
                    } />
                </DataTable>
            </div>
        </>
    );
}

const Form = (props)=>{
    const {visible, hide } = props.form;
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        PointParkingService.getEtatVehicule((data, status) => {
            setLoading(false);
            //console.log(JSON.stringify(data, null, 2));
            if(status) setItems(data);   
        },
            //{date: new Date().toISOString().slice(0, 10)}
            { etat: "EN_PANNE"}
        );
    }

    return(
            <Dialog visible={visible} style={{ width: '800px' }} header="Les véhicules en panne" modal className="p-fluid" 
                footer={
                    <>
                        <Button label="Fermer" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    </>
                } 
                onHide={hide}
                > 
                <DataTable dataKey="id" value={items}
                    paginator rows={itemPerPage} loading={loading} 
                    responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                    <Column field="id" header="Identifiant" sortable hidden />
                    <Column field="immatriculation" header="Immatriculation" sortable />
                    <Column field="marque" header="Marque" sortable />
                    <Column field="modele" header="Modèle" sortable />
                    <Column field="nbrePlace" header="Nombre de places" sortable />
                    <Column field="etatVehicule" header="Etat" sortable body={(item2) =>
                        <span className={`customer-badge status-${item2.etatVehicule === 'DISPONIBLE' ? 'qualified' : 'unqualified'}`}>
                            {item2.etatVehicule}
                        </span>
                    } />
                    <Column field="institution.libelle" header="Institution" sortable />
                </DataTable>

            </Dialog>
    )

}

const Form2 = (props)=>{
    const {visible, hide } = props.form2;
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        PointParkingService.getEtatVehicule((data, status) => {
            setLoading(false);
            if(status) setItems(data);   
        },
        { etat: "EN_BON_ETAT"}
        );
    }

    return(
            <Dialog visible={visible} style={{ width: '800px' }} header="Les véhicules en bon état" modal className="p-fluid" 
                footer={
                    <>
                        <Button label="Fermer" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    </>
                } 
                onHide={hide}
                > 
                <DataTable dataKey="id" value={items}
                    paginator rows={itemPerPage} loading={loading} 
                    responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                    <Column field="id" header="Identifiant" sortable hidden />
                    <Column field="immatriculation" header="Immatriculation" sortable />
                    <Column field="marque" header="Marque" sortable />
                    <Column field="modele" header="Modèle" sortable />
                    <Column field="nbrePlace" header="Nombre de places" sortable />
                    <Column field="etatVehicule" header="Etat" sortable body={(item2) =>
                        <span className={`customer-badge status-${item2.etatVehicule === 'DISPONIBLE' ? 'qualified' : 'unqualified'}`}>
                            {item2.etatVehicule}
                        </span>
                    } />
                    <Column field="institution.libelle" header="Institution" sortable />
                </DataTable>

            </Dialog>
    )

}

export default PointParking;